import { useParams } from 'react-router-dom'

export function useAppPath() {
  const params = useParams<{ slug?: string }>()
  return (path: string) => {
    const cleaned = path.startsWith('/') ? path : `/${path}`
    return params.slug ? `/o/${params.slug}/app${cleaned}` : `/app${cleaned}`
  }
}
